import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import backarrow from "../../../assets/images/back-arrow-left.svg";
import closeicon from "../../../assets/images/close.svg";
import { useLocation, useNavigate } from "react-router-dom";
import BottomStickyBtnLayout from "../newMotorPolicy/Layouts/BottomStickyBtnLayout";
import useRenewalFlow from "../../../hooks/useRenewalFlow";
import useScreenResolution from "../../../hooks/useScreenResolution";
import { claimPaths, emailOrMobileChangePaths, lifeInsuranceOverviewPaths, motorInsurancePaths, navigateToHomePaths, policyOverviewPaths } from "../../../components/common/Header/data";
import useLanguageTranslate from "../../../hooks/useLanguageTranslate";

const RenewMotorLayout = ({
  children,
  is_hide_back_btn,
  show_close_btn,
  btn_label,
  btn_onClick,
  btn_disabled,
  show_summary,
  is_bottom_sticky_layout = true,
  backClickHandler,
  tempPrice,
  tempIncluded,
  tempCarReplacement,
  AdditionalComponent,
  hideContinueBtn,
  isUploadingHistory,
  isLoading,
  onClose,
}) => {
  const navigate = useNavigate();
  const { mobile } = useScreenResolution();

  const { handlePrevSubstep, handlePrevStep } = useRenewalFlow();
  const translate = useLanguageTranslate();
  const { pathname, search } = useLocation();

  // Portal the mobile back/close button into a stable in-tree node
  // (#renew-motor-back-portal) provided by the host page, so an animating
  // ancestor cannot become the containing block for this fixed button.
  const [backPortalTarget, setBackPortalTarget] = useState(null);
  useEffect(() => {
    if (typeof document === "undefined") return;
    setBackPortalTarget(document.getElementById("renew-motor-back-portal"));
  }, []);

  const optionalcloseClickHanlder = () => {
    if (onClose) {
      onClose();
      return;
    }
    if (pathname?.includes("/new-motor-policy")) {
      navigate("/new-policy");
    } else if (navigateToHomePaths.some((path) => pathname?.includes(path))) {
      navigate("/");
    } else if (
      emailOrMobileChangePaths.some((path) => pathname?.includes(path))
    ) {
      if (mobile) {
        navigate("/profile-details");
      } else {
        navigate("/profile-settings");
      }
    } else if (policyOverviewPaths.some((path) => pathname?.includes(path))) {
      navigate(-1);
    } else if (claimPaths.some((path) => pathname?.includes(path))) {
      navigate("/file-a-claim");
    }
    else if (lifeInsuranceOverviewPaths.some((path) => pathname?.includes(path))) {
      navigate(`/life-insurance/policy-overview${search}&tabType=ManagePolicy`);
    }
    else  if (motorInsurancePaths.some((path) => pathname?.includes(path))) {
      navigate(-1);
    }
    else {
      navigate(-1)
    }
  };

  const handleBackClick = () => {
    if (typeof backClickHandler == "function") {
      backClickHandler();
    } else if (backClickHandler == "loggedOut") {
      handlePrevStep();
    } else {
      handlePrevSubstep();
    }
  };

  const showMobileClose = show_close_btn;
  const showMobileBack = !is_hide_back_btn && !showMobileClose;

  const mobileButton = (showMobileClose || showMobileBack) ? (
    <div className="block md:hidden">
      <button
        type="button"
        className="flex items-center justify-center w-10 h-10 fixed top-3 left-4 rtl:right-4 rtl:left-auto rounded-full bg-[#F6F8F9] hover:bg-gray-200 transition-colors z-[100]"
        aria-label={showMobileClose ? translate("Close", "إغلاق") : translate("Back", "رجوع")}
        onClick={showMobileClose ? optionalcloseClickHanlder : handleBackClick}
      >
        {showMobileClose ? (
          <img src={closeicon} alt="Close" className="w-5 h-5" />
        ) : (
          <img src={backarrow} alt="Back" className="w-5 h-5 rtl:rotate-180" />
        )}
      </button>
    </div>
  ) : null;

  return (
    <div className="">
      {mobileButton && (backPortalTarget ? createPortal(mobileButton, backPortalTarget) : mobileButton)}

      {/* Desktop back button — hidden on mobile (portaled button covers that) */}
      {!is_hide_back_btn && (
        <button
          className="hidden md:flex backButton bg-navy-blue py-2 rounded mt-20 absolute left-[26px] top-0 text-black text-sm not-italic font-semibold leading-6 tracking-[-0.084px] rtl:right-[26px]"
          onClick={handleBackClick}
        >
          <img src={backarrow} alt="Back arrow" className="1 rtl:rotate-180" />
          <span className="back-text inline">
            {translate("Back", "رجوع")}
          </span>
        </button>
      )}
      {is_bottom_sticky_layout ? (
        <BottomStickyBtnLayout
          isUploadingHistory={isUploadingHistory}
          show_summary={show_summary}
          btn_onClick={btn_onClick}
          btn_disabled={btn_disabled}
          btn_label={btn_label}
          price={tempPrice}
          included={tempIncluded}
          carReplacement={tempCarReplacement}
          AdditionalComponent={AdditionalComponent}
          hideContinueBtn={hideContinueBtn}
          isLoading={isLoading}
          passedFrom={"MotorRenewal"}
        >
          {children}
        </BottomStickyBtnLayout>
      ) : (
        children
      )}
    </div>
  );
};

export default RenewMotorLayout;
